import { Text } from "@chakra-ui/react";

function NumberField({ value, ...rest }) {
  // Apr 2025: previously used "n/a" to indicate missing data. This is often incorrect.
  // Now we use "" to indicate missing data, which is always correct.
  return (
    <Text align="right" {...rest}>{value?.toLocaleString('en-GB', { maximumFractionDigits: 4 }) ?? ""}</Text>
  );
}

export default NumberField;
